import React, { memo, useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { useSharedValue } from 'react-native-reanimated';
import Text from 'design-system/Text';
import InteractivePieChart from 'design-system/InteractivePieChart';
import BlurAmountView from 'design-system/BlurAmountView';
import { formatAmount } from 'utils';
import { selectIsScrambled } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { selectDefaultCurrency } from 'reducers/selectors';
const OverviewPieChart = ({ data, title }) => {
    const scrambled = useAppSelector(selectIsScrambled);
    const defaultCurrency = useAppSelector(selectDefaultCurrency);
    const selectedPieSliceKey = useSharedValue('none');
    const [selectedPie, setSelectedPie] = useState(undefined);
    const titleRef = useRef(title);
    const hasSelectedData = useRef(false);
    useEffect(() => {
        if (!hasSelectedData.current || titleRef.current !== title) {
            const firstKey = data[0]?.key;
            if (firstKey) {
                hasSelectedData.current = true;
                selectedPieSliceKey.value = firstKey;
                setSelectedPie(data[0]);
            }
        }
        titleRef.current = title;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, title]);
    const onSelectPieSlice = useCallback((pieSlice) => {
        selectedPieSliceKey.value = pieSlice.key;
        setSelectedPie(pieSlice);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const info = useMemo(() => {
        const pieSlice = data.find((item) => item.key === selectedPie?.key);
        if (pieSlice) {
            return {
                title: formatAmount(pieSlice.value, ('currency' in pieSlice.category && pieSlice.category.currency) ||
                    'GBP', 0),
                subTitle: 'name' in pieSlice.category ? pieSlice.category.name : '',
            };
        }
        return {
            title: formatAmount(0, defaultCurrency, 0),
            subTitle: title,
        };
    }, [data, defaultCurrency, selectedPie?.key, title]);
    return (<InteractivePieChart pieSlices={data} onSelectPieSlice={onSelectPieSlice} selectedPieSliceKey={selectedPieSliceKey}>
      <BlurAmountView enabled={scrambled}>
        <Text Numbers-24 numberOfLines={1}>
          {info.title}
        </Text>
      </BlurAmountView>
      <Text TextThin-14 Gray numberOfLines={1}>
        {info.subTitle}
      </Text>
    </InteractivePieChart>);
};
export default memo(OverviewPieChart);
